export const it = {
  lang: 'it',
  data: {
    'ROUTES': {
      'home': 'home',
      'features': 'funzionalita',
      'pricing': 'prezzi',
      'faq': 'faq',
      'help': 'aiuto',
      'forum': 'forum',
      'blog': 'blog',
      'member': 'membro',
      'login': 'accesso',
      'dashboard': 'pannello',
      'support': 'supporto',
      'tickets': 'ticket',
      'register': 'registrazione',
      'complete': 'completamento',
      'download': 'download',
      'contact': 'contatto',
      'profile': 'profilo',
      'general': 'generale',
      'address': 'indirizzo',
      'company': 'azienda',
      'other': 'altro',
      'subscription': 'abbonamento',
      'manage': 'gestisci',
      'accounts': 'account',
      'templates': 'modelli',
      'apps': 'apps',
      'legal': 'legale',
      'terms': 'termini',
      'privacy': 'privacy',
      'imprint': 'note-legali',
      'cancellation': 'disdetta',
      'error': 'errore',
      'item-management': 'gestione-articoli',
      'import-export': 'importa-esporta',
      'synchronization': 'sincronizzazione',
      'orders': 'ordini',
      'messages': 'messaggi',
      'marketing': 'marketing',
      'extra': 'extra',
      'ai': 'ia',
      'ebay-lister': 'ebay-lister',
      'gpsr': 'gpsr',
      'car-parts': 'ricambi-auto',
    },
    'LEGAL': {
      'META': {
        'TERMS': {
          'TITLE': 'Termini e condizioni - dewabit',
          'DESCRIPTION': 'I termini e le condizioni per l\'utilizzo di dewabit, il software di inserzione per i venditori eBay.',
        },
        'PRIVACY': {
          'TITLE': 'Informativa sulla privacy - dewabit',
          'DESCRIPTION': 'Come dewabit tratta e protegge i dati personali: la nostra informativa sulla privacy in sintesi.',
        },
        'IMPRINT': {
          'TITLE': 'Note legali - dewabit',
          'DESCRIPTION': 'Note legali e identificazione del fornitore BWS IT GmbH, editrice di dewabit.',
        },
        'CANCELLATION': {
          'TITLE': 'Disdici i contratti qui - dewabit',
          'DESCRIPTION': 'Disdici il tuo abbonamento dewabit online - senza accesso, con conferma di ricezione immediata.',
        },
      },
    },
    'NAV-LINKS': {
      'HOME': 'Home',
      'FEATURES': 'Funzionalità',
      'EBAY-LISTER': 'eBay Lister',
      'GPSR': 'GPSR',
      'CARPARTS': 'Ricambi auto',
      'DOWNLOAD': 'Download',
      'PRICING': 'Prezzi',
      'FAQ': 'FAQ',
      'HELP-PAGES': 'Pagine di aiuto',
      'FORUMS': 'Forum',
      'BLOG': 'Blog',
      'CONTACT': 'Contatti',
      'LOGIN': 'Accedi',
      'REGISTER': 'Registrati',
      'MEMBER': 'Area membri',
      'MEMBER-DASHBOARD': 'Pannello',
      'MEMBER-PROFILE': 'Profilo',
      'MEMBER-SUBSCRIPTION': 'Il tuo piano',
      'MEMBER-EBAY-ACCOUNTS': 'Account ebay',
      'MEMBER-TEMPLATES': 'Modelli',
      'MEMBER-APPS': 'Apps',
      'MEMBER-SUPPORT': 'Supporto',
      'IMPRINT': 'Note legali',
      'CANCELLATION': 'Disdici i contratti qui',
      'PRIVACY': 'Privacy',
      'TERMS': 'Termini',
      'LOGOUT': 'Esci',
      'ACCOUNT-MENU': 'Menu account',
    },
    'GLOBAL': {
      'ERROR': 'Errore',
      'ERROR-GENERAL': 'Qualcosa è andato storto. Riprova più tardi o contatta il nostro supporto.',
      'SESSION-EXPIRED': 'La sessione è scaduta, effettua nuovamente l\'accesso',
      'CANCEL': 'Annulla',
      'TRY-AGAIN': 'Riprova',
      'PLEASE-WAIT': 'Attendere prego',
      'ARE-YOU-SURE': 'Sei sicuro?',
      'SUCCESS': 'Operazione riuscita',
      'DELETE': 'Elimina',
      'WARNING': 'Attenzione',
      'INFO': 'Info',
      'CHARS-LEFT': 'caratteri rimanenti',
      'CLOSE': 'Chiudi',
      'CLOSE-WINDOW': 'Chiudi finestra',
      'COPY-TO-CLIPBOARD': 'Copia negli appunti',
      'YES': 'Sì',
      'NO': 'No',
      'CONFIRM': 'Conferma',
      'SELECT': 'Seleziona',
      'ACTIVE': 'Attivo',
      'INACTIVE': 'Inattivo',
      'DEFAULT': 'Predefinito',
      'SAVE-CHANGES': 'Salva modifiche',
      'FOOTER': {
        'IMPRINT': 'Note legali',
        'PRIVACY': 'Privacy',
        'TERMS': 'Termini',
      },
      'UPDATE-AVAILABLE': {
        'HEAD': 'Aggiornamento disponibile!',
        'BODY': 'È disponibile una nuova versione. Vuoi ricaricare la pagina adesso? Attenzione: ' +
          'le modifiche non salvate andranno perse.',
        'LATER': 'Più tardi',
        'RELOAD': 'Ricarica pagina',
      },
      'WEBSOCKET': {
        'TICKET-REPLY': 'Ha ricevuto una risposta al Suo ticket di supporto.'
      },
      'PAYMENT': {
        'SUBTOTAL': 'Subtotale senza IVA',
        'VAT': '{{VATPERCENT}}% di IVA su',
        'TOTAL': 'Totale',
        'AMOUNT-TO-PAY': 'Importo da pagare',
        'CB-TERMS': 'Ho letto i termini e le condizioni e li accetto',
        'OPEN-NEW-WINDOW': 'Apri in una nuova finestra',
        'CB-CANCELLATION': 'Richiedo e accetto che iniziate il servizio ordinato prima della scadenza del periodo di recesso. ' +
          'So che il mio diritto di recesso decade con il completo adempimento del contratto.',
        'CONTINUE-PAYPAL': 'Continua con PayPal',
      },
      'LOGIN-MODAL': {
        'HEAD': 'Inserisci i tuoi dati di accesso dewabit per accedere:',
        'E-MAIL': 'E-mail',
        'E-MAIL-PLACEHOLDER': 'Inserisci l\'indirizzo e-mail',
        'PASSWORD': 'Password',
        'PASSWORD-PLACEHOLDER': 'Inserisci la password',
        'LOGIN': 'Accedi',
        'LOGIN-SUCCESS': 'Accesso riuscito',
      },
      'COMMUNITY-PUSH': {
        'NEW-POST': 'Nuovo post di {{user}}',
        'NEW-THREAD': 'Nuova discussione di {{user}}: {{threadName}}',
      },
      'LOGOUT-SUCCESS': 'Disconnessione avvenuta con successo',
      'CTA-REGISTER': {
        'CTA-HEAD': 'Crea subito il tuo account gratuito!',
        'CTA-BODY': 'Registrazione e prova senza rischi, senza indicare dati di pagamento',
        'CTA-BTN': 'Registrati ora',
      }
    }
  },
};
